import React from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

import { FULFILLED } from '../../constants/constants'
import * as Styled from './styles'
import { useAppSelector } from '../../hooks'

const DeliveryInfo: React.FC = () => {
  const { summary } = useAppSelector((state) => state.bundle)
  const { applicationMode, content } = useAppSelector((state) => state.init)
  const { requestStatus_fetchPrices_aggregated } = useAppSelector((state) => state.requests.requestStatus)
  const { isSummaryPanelVisible } = useAppSelector((state) => state.ui)

  return (
    <Styled.DeliveryInfo applicationMode={applicationMode} $insideSummaryPanel={isSummaryPanelVisible}>
      {requestStatus_fetchPrices_aggregated === FULFILLED ? (
        <>
          <i className="fas fa-truck fa-lg" aria-hidden="true" />
          <span className="text">
            {summary?.DeliveryInformation}
            <a href={content.other.deliveryInfoLinkPath} target="_blank" rel="noopener noreferrer">
              {content.other.deliveryInfoLinkText}
            </a>
          </span>
        </>
      ) : (
        <Skeleton width="325px" height="50px" />
      )}
    </Styled.DeliveryInfo>
  )
}

export default DeliveryInfo
